import type { HTMLAttributes } from "react";
import s from "./Card.module.css";

export type CardProps = HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...rest }: CardProps) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return <div className={classes} {...rest} />;
}
